export default function suggestInit(coreHandlerInstance) {
  const suggestOutputArea = document.getElementsByClassName("js__suggest-area")[0];

  class suggestClass {
    static langArr =  {
      "ja": "選択した項目から検索する",
       "en": "Search by selected items",
       "cn": "按选定项目搜索"
    };
    static instanceList = [];
    static selectList = [];
    static firstSelect;
    static textArea = document.getElementsByClassName("js__case-search-input")[0] || null;
    static suggestOutputArea = document.getElementsByClassName("js__suggest-area")[0];

    static init = () => {
      let caseSearchInstance = coreHandlerInstance.searchClass.instanceList.filter(instance => instance.mode === "case");
      suggestClass.instanceList = caseSearchInstance.map(instance => {
        return new suggestClass(instance);
      });
      if (suggestClass.textArea) {
        suggestClass.textArea.addEventListener("input", () => {
          suggestClass.filterItemsByInput();
        });
      }

      document.addEventListener("click", suggestClass.handleDocumentClick);


      // DOMの生成を行う
      suggestClass.generateDOM();
    };


    static sanitizeInput(input) {
      return input ? input.replace(/[<>&"']/g, (match) => {
        switch (match) {
          case '<':
            return '&lt;';
          case '>':
            return '&gt;';
          case '&':
            return '&amp;';
          case '"':
            return '&quot;';
          case "'":
            return '&#39;';
          default:
            return match;
        }
      }) : '';
    }

    static haveMultipleParent(instance) {
      return instance.multipleParent !== null;
    }

    static getChildrenItems(instance) {
      if (instance.multipleSelector !== null) {
        return suggestClass.instanceList.filter((item) => item.multipleParent === instance.multipleSelector);
      }
      return [];
    }

    static modifyToSearchClass() {
      if (suggestClass.selectList.length < 1) return false;
      const modifyData = suggestClass.selectList.map(instance => {
        return coreHandlerInstance.searchClass.getInstanceByItemId(instance.itemId);
      });
    }


    static getObjectDiff() {
      let diffData = {
        add: [],
        remove: []
      };

      // searchClassのチェックされたリストを取得
      const searchSelectedList = coreHandlerInstance.searchClass.getCheckedItems();
      const suggestSelectedList = suggestClass.selectList;

      // 追加されたデータの取得
      diffData.add = suggestSelectedList.filter(item => !searchSelectedList.some(selectedItem => selectedItem.itemId === item.itemId)).map(item => item.itemId);

      // 削除されたデータの取得
      diffData.remove = searchSelectedList.filter(item => !suggestSelectedList.some(newItem => newItem.itemId === item.itemId)).map(item => item.itemId);

      return diffData;
    }


    static isMatch(suggestItem, sanitizedInput) {
      return suggestItem.label.toLowerCase().includes(sanitizedInput.toLowerCase());
    }

    static filterItemsByInput() {
      if(!suggestClass.textArea || suggestClass.textArea.value.length < 1){
        suggestClass.modalHidden();
        return; // textAreaが存在しないか、2文字未満の場合は何もしない
      }else if (!suggestClass.textArea || suggestClass.textArea.value.length < 2) {
        return; // textAreaが存在しないか、2文字未満の場合は何もしない
      }


      const sanitizedInput = suggestClass.sanitizeInput(suggestClass.textArea.value); // テキストエリアの入力をサニタイズ

      const matchingItems = suggestClass.instanceList.filter((suggestItem) => {
        return suggestClass.isMatch(suggestItem, sanitizedInput);
      });

      // console.log("matchingItems" , matchingItems );


      // マッチしたitemが親要素でmultipleSelectorを持つ場合、それをmultipleParentに持つitemを取得
      const multipleChildItems = matchingItems
        .filter((suggestItem) => suggestItem.multipleSelector !== null)
        .flatMap((suggestItem) => {
          return suggestClass.instanceList.filter(
            (item) => item.multipleParent === suggestItem.multipleSelector
          );
        });

      // console.log( "multipleChildItems", multipleChildItems);

      const selectSearchInstanceItemList = coreHandlerInstance.searchClass.getCheckedItems()
      const selectSuggestInstanceItemList = suggestClass.instanceList.filter(item => {
        return selectSearchInstanceItemList.some(suggestItem => item.itemId === suggestItem.itemId);
      });

      // multipleChildItemsとmatchingItemsをマージ
      const mergedItems = [...multipleChildItems, ...matchingItems];

      // idをキーにして重複を取り除く
      const uniqueItems = mergedItems.reduce((acc, item) => {
        if (!acc.some(existingItem => existingItem.itemId === item.itemId)) {
          acc.push(item);
        }
        return acc;
      }, []);


      // マッチしたアイテムのみ表示
      if (uniqueItems.length > 0) {
        suggestClass.suggestOutputArea.style.display = "block";
      } else {
        suggestClass.suggestOutputArea.style.display = "none";
      }

      // マッチしないアイテムは非表示
      suggestClass.instanceList.forEach((suggestItem) => {
        if (!uniqueItems.includes(suggestItem)) {
          suggestItem.hide();
        }
      });

      uniqueItems.forEach((suggestItem) => {
        suggestItem.show();
      });

    }

    static handleDocumentClick = (event) => {
      const isClickedOutside = !event.target.closest(".js__suggest-area");


      if (isClickedOutside) {
        // js__suggest-area 以外がクリックされた場合
        suggestClass.suggestOutputArea.style.display = "none";
      }
    };

    static rebuild = () => {
      const searchItemList = this.coreHandlerInstance.searchClass.getCheckedItems();

    }

    static modalHidden = () => {
      suggestClass.suggestOutputArea.style.display = "none";
    }

    static inputClear = () => {
      suggestClass.textArea.value = "";
    }

    static showAllItems() {
      // すべてのアイテムを表示
      suggestClass.instanceList.forEach((suggestItem) => {
        suggestItem.show();
      });
    }

    static getLang () {
      let buttonText = "";
      const langCode = WOVN.io.getCurrentLang().code;
      if (langCode == "ja") {
        buttonText = suggestClass.langArr.ja;
      } else if (langCode == "en") {
        buttonText = suggestClass.langArr.en;
      } else if (langCode == "zh-CHS") {
        buttonText = suggestClass.langArr.cn;
      }

      return buttonText;
    }

    static async generateDOM() {
      const container = document.createElement('div');
      container.classList.add("js__suggest-area__inner");
    
      const parentList = suggestClass.instanceList.filter(instance => instance.multipleSelector !== null);
    
      if (parentList.length > 0) {
        parentList.forEach(parentItem => {
          const wrapElement = document.createElement('div');
          wrapElement.classList.add('p-suggest-box');
          const divElement = suggestClass.generateItem(parentItem);
          wrapElement.appendChild(divElement);
    
          const childList = suggestClass.instanceList.filter(instance => instance.multipleParent == parentItem.multipleSelector);
    
          if (childList.length > 0) {
            childList.forEach(childItem => {
              const divElement = suggestClass.generateItem(childItem);
              wrapElement.appendChild(divElement);
            });
          }
    
          container.appendChild(wrapElement);
        });
      }
    
      suggestClass.suggestOutputArea.appendChild(container);
    
      // ボタン要素を作成
      const button = document.createElement("button");
      button.classList.add("p-btn", "js__suggest-btn");
    
      let buttonText = "選択した項目から検索する";


      buttonText = await new Promise(resolve => {
      
        if (window.WOVN && WOVN.io && WOVN.io.isApiReady()) {
          resolve(suggestClass.getLang());
        }else{
            window.addEventListener('wovnApiReady', () => {
              resolve(suggestClass.getLang());
            });
          }
      });

    
      button.textContent = buttonText; // ボタンのテキストを設定

      button.addEventListener("click", () => {
        const diffData = suggestClass.getObjectDiff();
        coreHandlerInstance.searchClass.getSuggestDiffEvent(diffData);
        suggestClass.inputClear();
        suggestClass.modalHidden();
      });
    
      // コンテナにボタンを追加
      suggestOutputArea.appendChild(button);
    }
    

    static generateItem(suggestItem ) {
    
        // <span>要素を作成
        const divElement = document.createElement('div');
        divElement.classList.add('p-property-box__name');
        divElement.classList.add('js__suggest-item');

        if (suggestItem.multipleSelector !== null) {
          divElement.classList.add('p-suggest-item__parent');
        }
        if (suggestItem.multipleParent !== null) {
          divElement.classList.add('p-suggest-item__child');
        }

        // チェックボックス要素を作成
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = `checkbox_${suggestItem.itemId}`;
        checkbox.autocomplete = 'off'; // autocomplete を追加
        checkbox.addEventListener('click', () => {
          suggestItem.clickHandler();
        }, true);

        // ラベル要素を作成
        const label = document.createElement('label');
        label.classList.add('p-property-box__label');
        label.textContent = suggestItem.label; // 適切なラベルを表示するように変更
        label.htmlFor = `checkbox_${suggestItem.itemId}`;

        // <span>に data-id と data-group 属性を追加
        divElement.setAttribute('data-id', suggestItem.itemId);
        divElement.setAttribute('data-group', suggestItem.groupId);
        divElement.setAttribute("data-property-name","用途事例-suggest");
        divElement.setAttribute("data-value", suggestItem.value );

        // <span>内にチェックボックスとラベルを追加
        divElement.appendChild(checkbox);
        divElement.appendChild(label);

        //生成したdomをeleプロパティに設定
        suggestItem.ele = divElement;
        return divElement;
    }

    static syncSelectedItems(selectedItems) {
      suggestClass.instanceList.forEach(suggestItem => {
        const match = selectedItems.find(selectedItem => {
          return suggestItem.propertyId === selectedItem.propertyId && suggestItem.itemId === selectedItem.itemId;
        });

        if (match) {
          suggestItem.select();
        } else {
          suggestItem.deselect();
        }
      });
    }


    static reset = () => {
      suggestClass.selectList = [];
      suggestClass.instanceList.map(instance => {
        instance.checked = false;
        instance.classList.remove("selected");
      });
    }

    constructor(instance) {
      this.instanceType = "suggestClass";
      this.itemId = instance.itemId ? instance.itemId : null;
      this.propertyId = instance.propertyId ? instance.propertyId : null;
      this.groupId = instance.groupId ? instance.groupId : null;
      this.suggestList = instance.suggestList ? instance.suggestList : null;
      this.label = instance.labelText;
      this.value = instance.value? instance.value: null;
      this.multipleSelector = instance.multipleSelector;
      this.multipleParent = instance.multipleParent;
      this.clickHandler = this.clickEvent.bind(this);
      this.checked = false;
    }

    clickEvent = () => {
      if (this.checked === false) {
        this.select();
      } else {
        this.deselect();
      }

      if (this.multipleParent !== null && this.checkEveryChildChecked() === true) return false;

      const parentList = this.getParentData(this);
      if (parentList.length < 1 || parentList === false ) return false;
      parentList.forEach(instance => instance.onlyParentDeselect());

    };

    checkEveryChildChecked = () => {
      const sameParentInstances = this.getSameChildrenData(this);
      return sameParentInstances.every(instance => instance.checked === true);
    }

    multipleSelect() {
      suggestClass.instanceList.forEach(instance => {
        if (instance.multipleParent === this.multipleSelector) {
          instance.select();
        }
      });
    }

    multipleRemove() {
      suggestClass.instanceList.forEach(instance => {
        if (instance.multipleParent === this.multipleSelector) {
          instance.deselect();
        }
      });
    }

    addSelect() {
      if (!suggestClass.selectList.includes(this)) {
        suggestClass.selectList.push(this);
      }
    }

    removeSelect() {
      const index = suggestClass.selectList.findIndex((item) => {
        return item.itemId === this.itemId && item.propertyId === this.propertyId;
      });

      if (index !== -1) {
        suggestClass.selectList.splice(index, 1);
      }
    }

    getParentData(argInstance = null) {
      if (argInstance === null) {
        return suggestClass.instanceList.filter(instance => instance.multipleSelector !== null);
      } else {
        if( argInstance.multipleParent === null ) return false;
        return suggestClass.instanceList.filter(instance => instance.multipleSelector == argInstance.multipleParent);
      }
    }

    getSameChildrenData(argInstance) {
      return suggestClass.instanceList.filter(instance => instance.multipleParent == argInstance.multipleParent);
    }

    select = () => {
      // 選択状態にする処理
      this.ele.classList.add("selected");
      this.ele.querySelector('input').checked = true;
      this.checked = true;

      if (this.multipleSelector !== null) {
        this.addSelect();
        this.multipleSelect();
      } else {
        this.addSelect();
      }
      this.checked = true;
    }

    deselect = () => {
      // 非選択状態にする処理
      this.ele.classList.remove("selected");
      this.ele.querySelector('input').checked = false;

      if (this.multipleSelector !== null) {
        this.removeSelect();
        this.multipleRemove();
      } else {
        this.removeSelect();
      }
      this.checked = false;
    }

    onlyParentDeselect = () => {
      this.ele.classList.remove("selected");
      this.ele.querySelector('input').checked = false;
      this.removeSelect();
      this.checked = false;
    };

    show = () => {
      // 表示する処理
      if (this.ele) {
        this.ele.style.display = 'flex';
      }
    }

    hide = () => {
      // 非表示にする処理
      if (this.ele) {
        this.ele.style.display = 'none';
      }
    }
  }

  suggestClass.init();

  // console.log("coreHandlerInstance.searchClass.instanceList", coreHandlerInstance.searchClass.instanceList);
  // console.log("suggestClass.instanceList", suggestClass.instanceList);
  return suggestClass;
}